/* tslint:disable */
/* eslint-disable */
/**
 * Analytics
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface ParameterizedQuery
 */
export interface ParameterizedQuery {
    /**
     * 
     * @type {string}
     * @memberof ParameterizedQuery
     */
    'sql': string;
    /**
     * 
     * @type {{ [key: string]: unknown; }}
     * @memberof ParameterizedQuery
     */
    'params'?: { [key: string]: unknown; } | null;
}
/**
 * @type QueriesValue
 * @export
 */
export type QueriesValue = ParameterizedQuery | string;

/**
 * 
 * @export
 * @enum {string}
 */

export const QueryContext = {
    FLOW_ANALYTICS: 'flow_analytics',
    CASE_ANALYTICS: 'case_analytics',
    EVENT_ANALYTICS: 'event_analytics',
    EVENT_ANALYTICS_SANDBOX: 'event_analytics_sandbox'
} as const;

export type QueryContext = typeof QueryContext[keyof typeof QueryContext];


/**
 * 
 * @export
 * @interface QueryError
 */
export interface QueryError {
    /**
     * 
     * @type {string}
     * @memberof QueryError
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface QueryRequest
 */
export interface QueryRequest {
    /**
     * 
     * @type {{ [key: string]: QueriesValue; }}
     * @memberof QueryRequest
     */
    'queries': { [key: string]: QueriesValue; };
    /**
     * 
     * @type {QueryContext}
     * @memberof QueryRequest
     */
    'context'?: QueryContext;
    /**
     * 
     * @type {string}
     * @memberof QueryRequest
     */
    'tz'?: string | null;
}


/**
 * 
 * @export
 * @interface QueryResponse
 */
export interface QueryResponse {
    /**
     * 
     * @type {{ [key: string]: ResultsValue; }}
     * @memberof QueryResponse
     */
    'results': { [key: string]: ResultsValue; };
}
/**
 * 
 * @export
 * @interface QueryResult
 */
export interface QueryResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryResult
     */
    'columns': Array<string>;
    /**
     * 
     * @type {Array<Array<unknown>>}
     * @memberof QueryResult
     */
    'rows': Array<Array<unknown>>;
    /**
     * 
     * @type {number}
     * @memberof QueryResult
     */
    'row_count': number;
}
/**
 * @type ResultsValue
 * @export
 */
export type ResultsValue = QueryError | QueryResult;

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
    /**
     * 
     * @type {unknown}
     * @memberof ValidationError
     */
    'input'?: unknown;
    /**
     * 
     * @type {object}
     * @memberof ValidationError
     */
    'ctx'?: object;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Execute a batch of validated SQL queries scoped to a realm context.  Accepts a map of {name: sql | {sql, params}} and returns a map of {name: result | error}. Each SQL string is parsed and validated against the realm\'s datasource allow-list, then regenerated from the validated AST before execution (closing TOCTOU / parser-differential gaps); per-query params are bound to its `$name` placeholders.
         * @summary Query Sql
         * @param {QueryRequest} queryRequest 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySqlAnalyticsApiV1QueryPost: async (queryRequest: QueryRequest, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queryRequest' is not null or undefined
            assertParamExists('querySqlAnalyticsApiV1QueryPost', 'queryRequest', queryRequest)
            const localVarPath = `/analytics/api/v1/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Execute a batch of validated SQL queries scoped to a realm context.  Accepts a map of {name: sql | {sql, params}} and returns a map of {name: result | error}. Each SQL string is parsed and validated against the realm\'s datasource allow-list, then regenerated from the validated AST before execution (closing TOCTOU / parser-differential gaps); per-query params are bound to its `$name` placeholders.
         * @summary Query Sql
         * @param {QueryRequest} queryRequest 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async querySqlAnalyticsApiV1QueryPost(queryRequest: QueryRequest, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.querySqlAnalyticsApiV1QueryPost(queryRequest, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.querySqlAnalyticsApiV1QueryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Execute a batch of validated SQL queries scoped to a realm context.  Accepts a map of {name: sql | {sql, params}} and returns a map of {name: result | error}. Each SQL string is parsed and validated against the realm\'s datasource allow-list, then regenerated from the validated AST before execution (closing TOCTOU / parser-differential gaps); per-query params are bound to its `$name` placeholders.
         * @summary Query Sql
         * @param {DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySqlAnalyticsApiV1QueryPost(requestParameters: DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueryResponse> {
            return localVarFp.querySqlAnalyticsApiV1QueryPost(requestParameters.queryRequest, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for querySqlAnalyticsApiV1QueryPost operation in DefaultApi.
 * @export
 * @interface DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest
 */
export interface DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest {
    /**
     * 
     * @type {QueryRequest}
     * @memberof DefaultApiQuerySqlAnalyticsApiV1QueryPost
     */
    readonly queryRequest: QueryRequest

    /**
     * 
     * @type {string}
     * @memberof DefaultApiQuerySqlAnalyticsApiV1QueryPost
     */
    readonly acceptEncoding?: string | null
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Execute a batch of validated SQL queries scoped to a realm context.  Accepts a map of {name: sql | {sql, params}} and returns a map of {name: result | error}. Each SQL string is parsed and validated against the realm\'s datasource allow-list, then regenerated from the validated AST before execution (closing TOCTOU / parser-differential gaps); per-query params are bound to its `$name` placeholders.
     * @summary Query Sql
     * @param {DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public querySqlAnalyticsApiV1QueryPost(requestParameters: DefaultApiQuerySqlAnalyticsApiV1QueryPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).querySqlAnalyticsApiV1QueryPost(requestParameters.queryRequest, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }
}



